import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { StandAlonePayment } = await import('@containers/Payment/StandAlonePayment');
    return {
        Component: StandAlonePayment,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
